import Vue from 'vue'
import {Mutation, Action, VuexModule, getModule, Module} from "vuex-module-decorators";
import store from "../store";
import {DeliousApiClient} from "@/_global/api_clients/DeliousApiClient";

@Module({
    name: "StoresStore",
    dynamic: true,
    store: store,
    namespaced: true
})
class StoresStore extends VuexModule {
    // state
    private _all: Delious.Store[] = [];
    private _storeById: { [storeId: number]: Delious.Store } = {};

    // getter
    get all() {
        return this._all || [];
    }

    get storeById(){
        return this._storeById || {};
    }

    @Action
    public async init() {
        const response: Delious.StoreListResponse = await DeliousApiClient.getStores();
        this.setRespnse(response.list);
        for (let i = 0; i < response.list.length; i++) {
            this.setStoreById(response.list[i]);
        }
    }

    @Mutation
    private setRespnse(menus: Delious.Store[]) {
        this._all = menus;
    }

    @Mutation
    private setStoreById(store: Delious.Store) {
        Vue.set(this._storeById, store.code, store);
    }

}

export default getModule(StoresStore);
